export default "__VITE_ASSET__Czk3WEhN__"